import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';

import { connectModal } from '../../../features/modal/hoc';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import {
  selectLoans,
  selectLoansPagination,
  selectLoansFilter,
  fetchAccountLoansActions,
  setAccountLoansFilterAction,
} from '../../../features/account-management/ducks';
import { LoanList } from '../../../features/loan-management/components';
import { apiCallIds as loanApiCallIds } from '../../../features/loan-management/api';

const mapStateToProps = state => ({
  loans: selectLoans(state),
  pagination: selectLoansPagination(state),
  filter: selectLoansFilter(state),
  isLoadingLoans: selectIsInProgress(state, loanApiCallIds.FETCH_LOANS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccountLoans: fetchAccountLoansActions.request,
      setFilter: setAccountLoansFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  status: 'AKT',
};

export const PAYMENT_SHIFT_MODAL = 'paymentManagement/modals/PAYMENT_SHIFT_MODAL';
@translate()
@connect(mapStateToProps, mapDispatchToProps)
@connectModal(PAYMENT_SHIFT_MODAL)
export default class PaymentShiftModal extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    account: PropTypes.object,
    accountFullName: PropTypes.string.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoadingLoans: PropTypes.bool.isRequired,
  };

  

  componentDidMount() {
      const { account, actions } = this.props;
      actions.setFilter({
        ...defaultFilter,
        accountId: account.id,
      });
  }

  onClose = e => {
    this.props.onClose && this.props.onClose(e);
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAccountLoans({
      ...this.props.filter,
      accountId: this.props.account.id,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { account, filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
      accountId: account.id,
    });
  };


  onFilterStatusChange = this.onFilterChange('status');

  render() {
    const {
      t,
      account,
      accountFullName,
      isLoading,
      loans,
      pagination,
      filter,
      isLoadingLoans,
      onSubmit,
      paymentId,
      
    } = this.props;

    if (!this.props.show) {
      return null;
    }

    return (
      <Modal
        title={t('Zvoľte pôžičku')}
        visible
        confirmLoading={isLoading}
        onCancel={this.onClose}
        footer={[
          <Button size="small" key="back" onClick={this.onClose}>
            {t('Zrušiť')}
          </Button>,
        ]}
        width={1500}
      >
        <h2>{accountFullName}</h2>
        <LoanList
          loans={loans}
          pagination={pagination}
          filter={filter}
          onTableChange={this.handleTableChange}
          onFilterStatusChange={this.onFilterStatusChange}
          isLoading={isLoadingLoans}
          actions={(text, loan) => (
            <Button size="small" onClick={() => onSubmit(paymentId, loan.id )}>
              {t('Presunúť platbu')}
            </Button> 
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/components/PaymentShiftModal.js